require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-vogue-living-boutique-beauty.json") })
        }
      }, "path---journal-vogue-living-boutique-beauty");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-vogue-living-boutique-beauty!./.cache/json/journal-vogue-living-boutique-beauty.json
// module id = 552
// module chunks = 231608221292675